import { BasicOnOff, Icon } from "@smartsuite/react-ui";
import { t } from "i18next";
import type { FunctionComponent } from "react";
import { useState } from "react";
import { useRootStore } from "../../stores/hooks";
import { InfoIcon } from "./InfoIcon/InfoIcon";
import * as S from "./style";
import type { UpdateSettings } from "./types";
import { UpdateModal } from "./UpdateModal";

interface Props {
  onChange: (updateSettings?: UpdateSettings) => void;
  updateSettings: UpdateSettings | undefined;
}

export const UpdateExistingRecordsButton: FunctionComponent<Props> = ({
  onChange,
  updateSettings,
}) => {
  const [update, setUpdate] = useState<boolean>(false);
  const [displayModal, setDisplayModal] = useState<boolean>(false);
  const { theme } = useRootStore();

  return (
    <>
      <S.Wrapper onClick={() => setDisplayModal(true)}>
        <S.OnOffWrapper onClick={(event) => update && event.stopPropagation()}>
          <BasicOnOff
            isChecked={update}
            size="s"
            onText=""
            offText=""
            onChange={(event) => {
              if (update) {
                setUpdate(false);
                onChange();
              }
            }}
          />
        </S.OnOffWrapper>

        <S.Text>{t("import.update-records")}</S.Text>
        <InfoIcon
          placements={["bottom"]}
          tooltipText={t("import.update-tooltip")}
        />
        {update && (
          <>
            <S.VerticalLine />
            <S.Space />
            <Icon name="settings" size="M" color={theme.primaryColor} />
          </>
        )}
      </S.Wrapper>
      {displayModal && (
        <UpdateModal
          updateSettings={updateSettings}
          onClose={() => setDisplayModal(false)}
          onSave={(updateSettings) => {
            setDisplayModal(false);
            setUpdate(true);
            onChange(updateSettings);
          }}
        />
      )}
    </>
  );
};
